var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39,
    height: 46.612,
    viewBox: "0 0 39 46.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_7268",
    x: 0,
    y: 0,
    width: 39,
    height: 46.612,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4836",
    "data-name": "Group 4836",
    transform: "translate(-830.5 -428.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_370",
    "data-name": "Ellipse 370",
    cx: 10,
    cy: 1.5,
    rx: 10,
    ry: 1.5,
    transform: "translate(840 462)",
    fill: "#747474",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 830.5, 428.5)",
    filter: "url(#Path_7268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7268-2",
    "data-name": "Path 7268",
    d: "M80.573,0a10.011,10.011,0,0,0-10,10c0,6.843,8.949,16.889,9.33,17.313a.9.9,0,0,0,1.34,0c.381-.424,9.33-10.47,9.33-17.313A10.011,10.011,0,0,0,80.573,0Zm0,15.031A5.031,5.031,0,1,1,85.6,10,5.037,5.037,0,0,1,80.573,15.031Z",
    transform: "translate(-61.07 6.5)",
    fill: "#f9a720",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon2);
export default __webpack_public_path__ + "static/media/mapIcon_2.94d52896172f9ea7b50a9e777e903847.svg";
export { ForwardRef as ReactComponent };